import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { trackedAction } from '../../utilities/track-execution-time';

/**
 * GetTdsDocumentDownload Input Action
 */
export class GetTDSDocumentDownloadInput implements Msdyn365.IActionInput {
    public productId: string;
    public businessUnit: string;

    constructor(productId: string, businessUnit: string) {
        this.productId = productId;
        this.businessUnit = businessUnit;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetTdsDocumentDownload-${this.productId}-${this.businessUnit}`;
    public getCacheObjectType = () => 'GetTdsDocumentDownload';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetTDSDocumentDownloadData {
    '@odata.context'?: string;
    value: IGetTDSDocumentItem[];
}

export interface IGetTDSDocumentItem {
    DocumentId: string;
    FileName: string;
    DownstreamSystem: string;
    ProductId: string;
    Url: string;
    Summary: string;
    Language: string;
    RecordCreatedDate: Date;
    ExtensionProperties: unknown[];
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetTDSDocumentDownloadInput('', '');
};

async function action(input: GetTDSDocumentDownloadInput, ctx: Msdyn365.IActionContext): Promise<IGetTDSDocumentDownloadData> {
    ensureAuthenticated(ctx);
    let getDocumentDownloadData: IGetTDSDocumentDownloadData = {} as IGetTDSDocumentDownloadData;

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/Document/GetDownloadMetaData`,
        'post',
        {
            productId: input.productId,
            businessUnit: input.businessUnit
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            },
            timeout: 30000
        }
    )
        .then(res => {
            getDocumentDownloadData = res?.data as IGetTDSDocumentDownloadData;
        })
        .catch(error => {
            return { error: { errorCode: error.response.status, errorText: error.response.statusText } };
        });
    return getDocumentDownloadData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetTDSDocumentDownloadData>>((input, ctx) => trackedAction(action, input, ctx, 'GetTdsDocumentDownload')),
    id: 'GetTdsDocumentDownload',
    input: createInput
});
